// D44 Items 4+5 — restart presentation. The sim teleports restart takers instantly (D38); the client
// hides that jump behind a short screen fade and, while black, re-orients the camera toward the restart
// spot so play resumes facing the right way. Presentation only — zero sim state. jsdom-testable (no THREE).

export class ScreenFade {
  private readonly el: HTMLDivElement;
  private busy = false;

  constructor(doc: Document) {
    this.el = doc.createElement('div');
    this.el.style.cssText = 'position:fixed;inset:0;background:#000;opacity:0;pointer-events:none;z-index:110;transition:opacity 200ms linear';
    doc.body.appendChild(this.el);
  }

  /** Fade to black over toBlackMs, run midAction while black, hold, then fade back over backMs. A
   *  re-trigger while a fade is in flight is ignored (never stacks). Total ≤ ~600 ms. */
  fadeThrough(midAction: () => void, toBlackMs = 200, holdMs = 120, backMs = 250): void {
    if (this.busy) return;
    this.busy = true;
    this.el.style.transition = `opacity ${toBlackMs}ms linear`;
    this.el.style.opacity = '1';
    setTimeout(() => {
      midAction();
      setTimeout(() => {
        this.el.style.transition = `opacity ${backMs}ms linear`;
        this.el.style.opacity = '0';
        setTimeout(() => {
          this.busy = false;
        }, backMs);
      }, holdMs);
    }, toBlackMs);
  }

  /** Current overlay opacity (0 clear … 1 black) — for tests. */
  get opacity(): number {
    return Number(this.el.style.opacity || '0');
  }
}
